// @ts-check
import React, { Component } from 'react';
import Modal from 'shared/components/Modal';
import { Link } from 'react-router';
import cx from 'classnames';
import ScheduledAt from './ScheduledAt';
import ChecklistProgress from 'shared/components/Referrals/IndexPage/ChecklistProgress';
import ReferralsTable from './ReferralsTable';
import FileAttachments from './FileAttachments';
import ReferralChecklist from 'shared/components/Referrals/ReferralChecklist';
import DropdownMenu, {
  DropdownTrigger,
  DropdownContent,
} from 'agent_portal/layouts/FuturePortalLayout/DropdownMenu';
import FileUploader from 'shared/components/Referrals/FileUploader';
import AppointmentCanceller from 'shared/components/Referrals/AppointmentCanceller';
import AppointmentNoShower from 'shared/components/Referrals/AppointmentNoShower';
import ReferralWithdrawer from 'shared/components/Referrals/ReferralWithdrawer';
import { browserHistory } from 'react-router';
import ChooseWarning from 'shared/components/Referrals/ChooseWarning';
import pluralize from 'pluralize';
import styles from './IndexPage.module.scss';
import Icon from 'shared/components/Icon';

const ReferralRow = ({ referral, showModal, handleSuccessfulModal, handleChooseClick }) => {
  const checklistPresent =
    referral.serializedReferralChecklist &&
    referral.serializedReferralChecklist.checklistItems &&
    referral.serializedReferralChecklist.checklistItems.length > 0;
  return (
    <tr
      id={`referral-${referral.id}`}
      className={cx(referral.referralPriorityCssClass, {
        [styles.reminders_awake]: referral.reminderStatus === 'awake',
        [styles.reminders_asleep]: referral.reminderStatus === 'asleep',
        [styles.reminders_completed]: referral.reminderStatus === 'completed',
        [styles.stat]: referral.stat,
        [styles.unbooked]: !referral['booked?'],
        [styles.active]: referral['active?'],
      })}
    >
      <td className={styles.reminder_status}>
        {referral.reminderStatus === 'completed' && (
          <Icon name="checkmark" cssTip="All reminders have been completed" />
        )}
        {referral.reminderStatus === 'awake' && (
          <Icon name="bell" cssTip="A reminder is due for completion" />
        )}
        {referral.reminderStatus === 'asleep' && (
          <Icon name="hour-glass" cssTip="There is an incomplete scheduled reminder" />
        )}
        {referral.reminderStatus === null && (
          <Icon name="radio-unchecked" cssTip="There are no reminders" />
        )}
      </td>
      <td>
        <Link className="btn btn-mini btn-info" to={`/a/portal/referrals/${referral.id}`}>
          View Details
        </Link>
        <br />
        {referral.fileAttachments.length > 0 ? (
          <span className="secondaryData">
            <span
              className="fake-link"
              onClick={() => showModal('viewFileAttachments', referral.id)}
            >
              {pluralize('file', referral.fileAttachments.length, true)}
            </span>
          </span>
        ) : null}
      </td>
      <td className={referral.referralPriorityCssClass}>
        {referral.createdAt}
        <br />
        <span className="secondaryData">{referral.specialtyName}</span>
      </td>
      <td>
        <strong>{referral.fullName}</strong>
        <br />
        <span className="secondaryData">Provider: {referral.referringProviderName}</span>
      </td>
      <td data-spec-class="receiving-provider">
        {referral.receivingProviderName}
        <br />
        <span className="secondaryData">{referral.receivingLocationName}</span>
      </td>

      <td>
        <span className={referral.statusBootstrapClass}>{referral.statusName}</span>
        {referral.stat && (
          <span>
            {' '}
            <span className={cx(styles.stat, 'label')}>STAT</span>
          </span>
        )}
        <br />
        <ScheduledAt referral={referral} showReplacedBy />
      </td>
      <td
        className={cx('taskStatus', { 'button-td': checklistPresent })}
        onClick={() => checklistPresent && showModal('checklist', referral.id)}
      >
        {checklistPresent && <span className="myTooltip">Click to view checklist</span>}
        {checklistPresent && <ChecklistProgress checklist={referral.serializedReferralChecklist} />}
      </td>
      <td>
        {' '}
        <DropdownMenu>
          <DropdownTrigger>
            <span className="fake-link">More...</span>
          </DropdownTrigger>
          <DropdownContent>
            <div>
              <ul>
                <li>
                  <a onClick={() => showModal('file', referral.id)}>Upload Files</a>
                </li>
                {referral['appointmentCancellable?'] && (
                  <li className="danger">
                    <a onClick={() => showModal('cancel', referral.id)}>Cancel</a>
                  </li>
                )}
                {referral['appointmentNoShowable?'] && (
                  <li className="danger">
                    <a onClick={() => showModal('noshow', referral.id)}>No Show</a>
                  </li>
                )}
                {referral['withdrawable?'] && (
                  <li className="danger">
                    <a onClick={() => showModal('withdraw', referral.id)}>Withdraw</a>
                  </li>
                )}
                {!referral.replacedById && (
                  <li className="danger">
                    <a onClick={() => handleChooseClick(referral)}>
                      {referral['hasOrganization?'] ? 'Choose New' : 'Choose'} Location/Provider
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </DropdownContent>
        </DropdownMenu>
      </td>
    </tr>
  );
};

class TableComponent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { referralId: null, openModal: null };
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleSuccessfulModal = this.handleSuccessfulModal.bind(this);
    this.handleChooseClick = this.handleChooseClick.bind(this);
  }

  hideModal() {
    this.setState({ openModal: null });
  }

  showModal(name, referralId) {
    this.setState({ openModal: name, referralId });
  }

  handleSuccessfulModal() {
    this.props.refresh();
    this.hideModal();
  }

  handleChooseClick(referral) {
    if (referral['active?'] && referral['hasOrganization?']) {
      this.showModal('choose', referral.id);
    } else {
      browserHistory.push(
        `a/portal/referral_profiles/${referral.referralProfileId}/referral_dashboard`
      );
    }
  }

  render() {
    const { referrals, refresh } = this.props;
    const referralId = this.state.referralId;
    const referral = referralId ? referrals.find(r => r.id === this.state.referralId) : undefined;
    return (
      <div>
        {referral && (
          <div>
            <Modal show={this.state.openModal === 'withdraw'} onHide={this.hideModal}>
              <ReferralWithdrawer
                referralId={referralId}
                handleSuccess={this.handleSuccessfulModal}
                apiEndpoint="/agent_portal/api"
              />
            </Modal>
            <Modal show={this.state.openModal === 'checklist'} onHide={this.hideModal}>
              <ReferralChecklist
                referralId={referralId}
                apiEndpoint="/agent_portal/api"
                checkable={false}
                editable={false}
                handleSuccess={refresh}
              />
            </Modal>
            <Modal show={this.state.openModal === 'file'} onHide={this.hideModal}>
              <FileUploader
                referralId={referralId}
                handleSuccess={this.handleSuccessfulModal}
                apiEndpoint="/agent_portal/api"
              />
            </Modal>
            <Modal show={this.state.openModal === 'cancel'} onHide={this.hideModal}>
              <AppointmentCanceller
                appointmentId={referral.appointmentId}
                handleSuccess={this.handleSuccessfulModal}
                apiEndpoint="/agent_portal/api"
              />
            </Modal>
            <Modal show={this.state.openModal === 'noshow'} onHide={this.hideModal}>
              <AppointmentNoShower
                appointmentId={referral.appointmentId}
                handleSuccess={this.handleSuccessfulModal}
                apiEndpoint="/agent_portal/api"
              />
            </Modal>
            <Modal show={this.state.openModal === 'choose'} onHide={this.hideModal}>
              <ChooseWarning referral={referral} webpageBase={'/a/portal'} />
            </Modal>
            <Modal show={this.state.openModal === 'viewFileAttachments'} onHide={this.hideModal}>
              <div className="modal-header">
                <h3>Files</h3>
              </div>
              <div className="modal-body">
                <FileAttachments referral={referral} handleSuccess={refresh} />
              </div>
            </Modal>
          </div>
        )}
        <table className="table table-bordered" data-spec-class="referrals">
          <thead>
            <tr>
              <th />
              <th>Details</th>
              <th>Referral</th>
              <th>Patient</th>
              <th>Referred To</th>
              <th>Status</th>
              <th>Checklist</th>
              <th>More</th>
            </tr>
          </thead>
          <tbody>
            {referrals.map(r => (
              <ReferralRow
                key={r.id}
                referral={r}
                showModal={this.showModal}
                handleSuccessfulModal={this.handleSuccessfulModal}
                handleChooseClick={this.handleChooseClick}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const SentReferralsTable = props => <ReferralsTable {...props} tableComponent={TableComponent} />;

export default SentReferralsTable;
